import React from "react";

import type { Impulse } from "~/tools/impulse";

import { DropdownWithHostContextProvider } from "./_dropdown-with-host-context";

export const DropdownWithHostProvider: React.FC<
	React.PropsWithChildren<{
		isOpen: Impulse<boolean>;
	}>
> = ({ isOpen, ...props }) => <DropdownWithHostContextProvider value={isOpen} {...props} />;
